import React from 'react';
import Warning from './Warning';
import {isObservableArray} from 'mobx';
import {isArray} from 'lodash';

export default class WarningsContainer extends React.Component {
    render() {
        if (isArray(this.props.warning) || isObservableArray(this.props.warning)) {
            return this.props.warning.map((w, index) => (
                <Warning key={index} warning={w}/>
            ))
        }

        return (
            <Warning warning={this.props.warning}/>
        )
    }
}